export default __webpack_public_path__ + "static/media/single-doctor.ed981672.jpg";